/// Globals required by this module
/// * Stripe
/// * tiller - configuration options

const tiller = window.tiller || {};

import './analytics/analytics-gtag.module';

import APIServicesModule from 'api-services/api-services.module';
import CoreServicesModule from 'core-services/core-services.module';
import OBQModule from 'app/obq/obq.module';
import LinkedSheetsModule from './sheets/linked-sheets.module';
import LinkedAccountsModule from './accounts/linked/linked-accounts.module';
import ArchivedAccountsModule from './accounts/archived/archived-accounts.module';
import SystemStatusModule from './system-status.module';
import StatusPageModule from './status-page/status-page.module';
import PusherModule from './pusher/pusher.module';
import FastlinkModule from './fastlink/fastlink.module';
import EventsService from './events/events.service';

const dependencies = [
  'ngCookies',
  'angulartics',
  'angulartics.google.gtag',
  'ui.bootstrap',
  'ngIntercom',
  'ngAnimate',
  'angularMoment',
  APIServicesModule.moduleName,
  CoreServicesModule.moduleName,
  OBQModule.moduleName,
  ArchivedAccountsModule.moduleName,
  LinkedAccountsModule.moduleName,
  LinkedSheetsModule.moduleName,
  SystemStatusModule.moduleName,
  StatusPageModule.moduleName,
  PusherModule.moduleName,
  FastlinkModule.moduleName
];

import RemoveAccountService from './accounts/remove-account.service';
import InterstitialController from './interstitial.controller';
import PreferencesController from './preferences.controller';
import SheetController from './sheet.controller';
import SheetListController from './sheets/sheet-list.controller';
import SubscriptionController from './subscription.controller';
import TillerAppController from './tiller-app.controller';
import AccountsController from './accounts/accounts.controller';
import SectionControllerBase,
  { SectionControllerBase as SectionControllerBaseFn } from './section_controller_base';
import { IncidentListController } from './status-page/incident-list.component';


var app = angular.module("Sheets", dependencies)
  .factory('stripe', function(STRIPE_PUBLISHABLE_KEY) {
    // @ts-ignore
    return Stripe(STRIPE_PUBLISHABLE_KEY);
  })
  .controller('AccountsCtrl', AccountsController)
  .controller('CollapsibleCtrl', SectionControllerBase)
  .controller('InterstitialCtrl', InterstitialController)
  .controller('PreferencesCtrl', PreferencesController)
     .service('removeAccountService', RemoveAccountService)
    .constant('section_controller_base', SectionControllerBaseFn)
  .controller('SheetCtrl', SheetController)
  .controller('SheetListCtrl', SheetListController)
  .controller('SubscriptionCtrl', SubscriptionController)
  .controller('TillerAppCtrl', TillerAppController)
  .service('EventsService', EventsService);

angular.module("Sheets")
  .constant('MAINTENANCE', tiller.maintenance)
  .constant('TAG_PROPERTY_IDS', tiller.googlePropertyIds)
  .constant('STRIPE_PUBLISHABLE_KEY', tiller.stripePublicKey)
  .constant('FEATURES', tiller.features)
  .constant('INTERCOM_APPID', tiller.intercomAppId) // can be set asynchronously
  .constant('DEFAULT_MAX_SHEETS_PER_USER', tiller.defaultMaxSheetsPerUser);

angular.module("statusPage")
  .constant("pageId", tiller.statusPageId);

angular.module(PusherModule.moduleName)
   .constant("apiKey", tiller.pusher.key)
   .constant("cluster", tiller.pusher.cluster);


app.config(function($locationProvider) {
  $locationProvider.html5Mode({
    enabled: false,
  });
});

app.config(function($intercomProvider, INTERCOM_APPID) {
  $intercomProvider.appID(INTERCOM_APPID);
  $intercomProvider.asyncLoading(true);
});

app.config(function ($analyticsProvider, TAG_PROPERTY_IDS) {
  // Configure to do explicit page tracking, manually
  $analyticsProvider.virtualPageviews(false);
  $analyticsProvider.firstPageview(false);
  $analyticsProvider.withAutoBase(false);
  $analyticsProvider.settings.tagPropertyIds = TAG_PROPERTY_IDS;
});


app.factory('$errorReporter', ['$log', '$window', function($log, $window) {
  var StackdriverErrors = new $window.StackdriverErrorReporter();
  if (tiller.errorLogging) {
    StackdriverErrors.start(tiller.errorLogging);
  }

  function reporter(err, cause) {
    if (err.message && err.stack) {
      StackdriverErrors.report(err);
      $log.warn('Reported error:', err);
    } else if (err && err.status && err.config) {
      StackdriverErrors.report(new Error("Error " + err.status + " at " + err.config.url));
      $log.warn('Reported error:', {status: err.status, url: err.config.url});
    } else {
      StackdriverErrors.report(new Error("Unknown error: " + JSON.stringify(err)));
    }
  };

  reporter.setUser = function(userId) {
    StackdriverErrors.setUser(userId);
  };

  return reporter;
}]);

app.config(function($httpProvider) {
  $httpProvider.interceptors
    .push(function($q, $errorReporter) {
      return {
        'responseError': function(rejection) {
          if (rejection.status != 401) {
            $errorReporter(rejection);
          }

          return $q.reject(rejection);
        }
      };
    });
});

function modal_instance_controller($scope, $uibModalInstance) {
  $scope.ok = function () {
    $uibModalInstance.close();
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
};

app.controller("ModalInstanceCtrl", modal_instance_controller);
